import { render } from "./AppLayoutBase.vue?vue&type=template&id=6ef66846"
import script from "./AppLayoutBase.vue?vue&type=script&lang=js"
export * from "./AppLayoutBase.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ayion/dev/dork/fmoj-vacms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__